import React from "react";

interface Props {
  tabs: string[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

export default function TabBar({ tabs, selectedTab, setSelectedTab }: Props) {
  return (
    <div className="border-b border-slate-200 px-4 mb-4">
      <nav className="flex justify-center space-x-6" role="tablist">
        {tabs.map((tab) => {
          const isSelected = selectedTab === tab;
          return (
            <button
              type="button"
              key={tab}
              role="tab"
              aria-selected={isSelected}
              onClick={() => setSelectedTab(tab)}
              className={`relative py-3 px-2 text-sm font-medium transition-colors duration-150 min-h-[44px] rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--color-primary)] ${
                isSelected
                  ? "text-primary"
                  : "text-slate-700 hover:text-primary"
              }`}
            >
              {tab}
              {isSelected && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
